export default __webpack_public_path__ + "static/ICICI-RIA-b9ec5529a54f6b52a16bd77ec0e0584b.png";